import { getServiceUrl } from "../api";
import RequestService from "../httpRequest";

export default {
  // 分页查询音色资源
  getVoiceCloneList(params, callback) {
    RequestService.sendRequest()
      .url(`${getServiceUrl()}/voiceClone`)
      .method("GET")
      .data(params)
      .success((res) => {
        RequestService.clearRequestTime();
        callback(res);
      })
      .networkFail((err) => {
        console.error("获取音色列表失败:", err);
        RequestService.reAjaxFun(() => {
          this.getVoiceCloneList(params, callback);
        });
      })
      .send();
  },

  deleteMine(id, callback) {
    RequestService.sendRequest()
      .url(`${getServiceUrl()}/voiceClone/${id}`)
      .method("DELETE")
      .success((res) => {
        RequestService.clearRequestTime();
        callback(res);
      })
      .networkFail((err) => {
        console.error("删除定制音色失败:", err);
        RequestService.reAjaxFun(() => {
          this.deleteMine(id, callback);
        });
      })
      .send();
  },

  // 更新音色名称
  updateName(params, callback) {
    RequestService.sendRequest()
      .url(`${getServiceUrl()}/voiceClone/updateName`)
      .method("POST")
      .data(params)
      .success((res) => {
        RequestService.clearRequestTime();
        callback(res);
      })
      .networkFail((err) => {
        console.error("更新名称失败:", err);
        RequestService.reAjaxFun(() => {
          this.updateName(params, callback);
        });
      })
      .send();
  },

  // 获取音频下载ID
  getAudioId(id, callback) {
    RequestService.sendRequest()
      .url(`${getServiceUrl()}/voiceClone/audio/${id}`)
      .method("POST")
      .success((res) => {
        RequestService.clearRequestTime();
        callback(res);
      })
      .networkFail((err) => {
        console.error("获取音频ID失败:", err);
        RequestService.reAjaxFun(() => {
          this.getAudioId(id, callback);
        });
      })
      .send();
  },

  // 获取音频播放URL
  getPlayVoiceUrl(uuid) {
    return `${getServiceUrl()}/voiceClone/play/${uuid}`;
  },

  // 生成测试语音
  generateTestVoice(formData, callback, errorCallback) {
    RequestService.sendRequest()
      .url(`${getServiceUrl()}/voiceClone/generateTestVoice`)
      .method("POST")
      .data(formData)
      .success((res) => {
        RequestService.clearRequestTime();
        callback(res);
      })
      .fail((res) => {
        // 业务失败回调
        RequestService.clearRequestTime();
        if (errorCallback) {
          errorCallback(res);
        } else {
          callback(res);
        }
      })
      .networkFail((err) => {
        console.error("生成测试语音失败:", err);
        RequestService.reAjaxFun(() => {
          this.generateTestVoice(formData, callback, errorCallback);
        });
      })
      .send();
  },

  // 保存本地克隆音色
  saveLocalVoice(formData, callback, errorCallback) {
    RequestService.sendRequest()
      .url(`${getServiceUrl()}/voiceClone/saveLocalVoice`)
      .method("POST")
      .data(formData)
      .success((res) => {
        RequestService.clearRequestTime();
        callback(res);
      })
      .fail((res) => {
        // 业务失败回调
        RequestService.clearRequestTime();
        if (errorCallback) {
          errorCallback(res);
        } else {
          callback(res);
        }
      })
      .networkFail((err) => {
        console.error("保存本地音色失败:", err);
        RequestService.reAjaxFun(() => {
          this.saveLocalVoice(formData, callback, errorCallback);
        });
      })
      .send();
  },

  getVoiceCloneBackend(callback, errorCallback) {
    RequestService.sendRequest()
      .url(`${getServiceUrl()}/voiceClone/voice-clone-backend`)
      .method("GET")
      .success((res) => {
        RequestService.clearRequestTime();
        callback(res);
      })
      .fail((res) => {
        RequestService.clearRequestTime();
        if (errorCallback) {
          errorCallback(res);
        } else {
          callback(res);
        }
      })
      .networkFail((err) => {
        console.error("获取克隆后端偏好失败:", err);
        RequestService.reAjaxFun(() => {
          this.getVoiceCloneBackend(callback, errorCallback);
        });
      })
      .send();
  },

  setVoiceCloneBackend(backend, callback, errorCallback) {
    RequestService.sendRequest()
      .url(`${getServiceUrl()}/voiceClone/voice-clone-backend`)
      .method("PUT")
      .data({ backend })
      .success((res) => {
        RequestService.clearRequestTime();
        callback(res);
      })
      .fail((res) => {
        RequestService.clearRequestTime();
        if (errorCallback) {
          errorCallback(res);
        } else {
          callback(res);
        }
      })
      .networkFail((err) => {
        console.error("保存克隆后端偏好失败:", err);
        RequestService.reAjaxFun(() => {
          this.setVoiceCloneBackend(backend, callback, errorCallback);
        });
      })
      .send();
  },
};
